<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				name="请假流程"
				label="请假流程"
				placeholder="选择请假流程"
				readonly
				value-key="process_name"
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择请假流程' }]"
			/>
			<van-field
				v-model="form.type_text"
				name="请假类型"
				label="请假类型"
				placeholder="选择请假类型"
				readonly
				@click="popup.type = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择请假类型' }]"
			/>
			<van-field
				v-model="form.start_date"
				name="开始日期"
				label="开始日期"
				placeholder="选择开始日期"
				readonly
				@click="popup.start_date = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择开始日期' }]"
			/>
			<van-field
				v-model="form.end_date"
				name="结束日期"
				label="结束日期"
				placeholder="选择结束日期"
				readonly
				@click="popup.end_date = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择结束日期' }]"
			/>
			<van-field
				v-model="form.day"
				name="请假天数"
				type="number"
				label="请假天数"
				placeholder="输入请假天数"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入请假天数' }]"
			/>
			<!-- <van-field
				v-model="date"
				name="请假日期"
				label="请假日期"
				placeholder="选择请假日期"
				readonly
				@click="popup.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择请假日期' }]"
			/> -->
			<van-field
				v-model="form.cause"
				rows="3"
				autosize
				label="请假事由"
				type="textarea"
				placeholder="请输入请假事由"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写请假事由' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.type" position="bottom">
			<van-picker
				show-toolbar
				:columns="typeList"
				@cancel="picker.type = false"
				@confirm="confirmType"
			/>
		</van-popup>
		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="picker.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.start_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.start_date = false"
				@confirm="confirmStartTime"
			/>
		</van-popup>
		<van-popup v-model="popup.end_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.end_date = false"
				@confirm="confirmEndTime"
			/>
		</van-popup>
		<van-calendar v-model="popup.calendar" type="range" @confirm="confirmCalendar" />
	</div>
</template>

<script>
import { getNowFormatDateTime } from "@/utils/tool";
// import { getNowFormatDate } from "@/utils/tool";
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "leave",
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			date: "",
			minDate: new Date(),
			// maxDate: new Date(),
			form: {
				type_text: "",
				type: "",
				start_date: "",
				end_date: "",
				cause: ""
			},
			popup: {
				type: false,
				calendar: false,
				process: false,
				start_date: false,
				end_date: false
			},
			processList: [],
			typeList: [
				{ text: "年假", id: 0 },
				{ text: "事假", id: 1 },
				{ text: "病假", id: 2 },
				{ text: "调休假", id: 3 },
				{ text: "婚假", id: 4 },
				{ text: "产假", id: 5 },
				{ text: "陪产假", id: 6 },
				{ text: "其他", id: 7 }
			]
		};
	},
	mounted() {
		this.getLeaveList();
	},
	methods: {
		onSubmit() {
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  "0"
			});
		},
		confirmType(value) {
			this.form.type_text = value.text;
			this.form.type = value.id;
			this.popup.type = false;
		},
		// confirmCalendar(value) {
		// 	this.form.start_date = getNowFormatDate(value[0]);
		// 	this.form.end_date = getNowFormatDate(value[1]);
		// 	this.date = this.form.start_date + " - " + this.form.end_date;
		// 	this.popup.calendar = false;
		// },
		confirmStartTime(val) {
			this.form.start_date = getNowFormatDateTime(val);
			this.popup.start_date = false;
		},
		confirmEndTime(val) {
			this.form.end_date = getNowFormatDateTime(val);
			this.popup.end_date = false;
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		getLeaveList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.date = "";
		}
	}
};
</script>